export default __webpack_public_path__ + "icons/mstile-144x144-6d80358e042c375667b71f69a41a7114.png";